import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClaimInsentifSummaryPage } from './claim-insentif-summary.page';

const routes: Routes = [
  {
    path: '',
    component: ClaimInsentifSummaryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimInsentifSummaryPageRoutingModule {}
